<div fxLayout="row" fxLayoutAlign="end center" >
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="center center" >
    <label mat-dialog-title class="otpHeader responsive-text-align-center" >Enter your verification code</label>
    <p class = "responsive-text-align-center responsive-otp-text">Please enter the 6-digit code sent to {{data.email}}</p>
</div>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
    <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="config"></ng-otp-input>
    <div fxLayout="row" fxLayoutAlign="center center">
        <mat-icon  class="material-icons-outlined" >timer</mat-icon><span>{{timeLeft}} Seconds</span>
    </div>
    <div fxLayout="row" fxLayoutGap="20px">
        <button  (click)="confirmOTP()" [disabled]="!otp"  class="verify-btn" fxLayoutAlign="center center" style="padding:10px; width: 220px;background: #386AF6; color:#fff">
            CONFIRM <mat-icon>
          chevron_right
        </mat-icon></button>
    </div>
    <a class="hidden-sm" style="color:#386AF6;cursor: pointer;" (click)="closePopup()">Change Email Id</a>
    <div class = "responsive-text-align-center">
        Did not receive code?<button (click)="resendOTP()" [disabled]="timeLeft != 0" class="resend-btn"> Resend</button>
    </div>
    <div fxLayoutAlign="center end" *ngIf="showNotification">
        <div class="notification" fxLayoutAlign="center end">
           {{notificationMessage}}
        </div>
    </div>
    <div fxLayoutAlign="center end" *ngIf="invalidOtpNotification">
        <div class="notification" fxLayoutAlign="center end">
           {{InvalidMessage}}
        </div>
    </div>
   
</div>
        